import React, { Component } from "react";
import { onChange, setError, validateForm } from "../../utils";
import NumberFormat from "react-number-format";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import {

    formatPhoneNumberIntl,
} from "react-phone-number-input";
import constant from "../../constant";
import {
    companyExist,
    emailExist,
    registerstepone,
    reSendOTP,
} from "../../action/auth";
import { Link } from "react-router-dom";
import Otp from "../Common/OTP";
import Swal from "sweetalert2";
import ModalWindow1 from "../Common/ModalWindow1";
import Loader from "../Common/Loader";
export default class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTimer: false,
            company_category: {
                name: "company_category",
                value: "CONSULTANT",
                error: "",
                isRequired: true,
            },
            company_name: {
                name: "company_name",
                value: "",
                error: "",
                isRequired: true,
            },
            email: { name: "email", value: "", error: "", isRequired: true },
            contact_person_name: {
                name: "contact_person_name",
                value: "",
                error: "",
                isRequired: true,
            },
            // phone_code: { name: 'phone_code', value: '', error: '', isRequired: true },
            mobile: { name: "mobile", value: "", error: "", isRequired: true },
            password: { name: "password", value: "", error: "", isRequired: true },
            condfirm_password: { name: "condfirm_password", value: "", error: "", isRequired: true },

            industry_type: {
                name: "industry_type",
                value: "",
                error: "",
                isRequired: false,
            },
            pin_code: { name: "pin_code", value: "", error: "", isRequired: true },
            gst: { name: "gst", value: "", error: "", isRequired: false },
            condition1: {
                name: "condition1",
                value: false,
                error: "",
                isRequired: false,
            },
            condition2: {
                name: "condition2",
                value: true,
                error: "",
                isRequired: false,
            },
            phone: "",
            ShowOtpInput: false,
            // resendOtpMessage: "",
            model: {},
            emailAvailable: false,
            companyNameAvailable: false,
            showLoader: false,
            timer: 30,
            showPasswordOne: false,
            showPasswordTwo: false

        };
    }

    chooseCompanyType = (e, value) => {
        e.preventDefault();
        onChange(this, "company_category", value);
    };

    onChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        if (name === "condition1") {
            onChange(this, name, !this.state.condition1.value);
        } else if (name === "condition2") {
            onChange(this, name, !this.state.condition2.value);
        } else if (name === "company_name") {

            if (value.length > 3) {
                companyExist(value).then((res) => {
                    if (res.status) {
                        this.setState({ companyNameAvailable: res.result.isExist });
                    }
                });
            }
            onChange(this, name, value);
        } else if (name === "email") {
            onChange(this, name, value);
            emailExist(value).then((res) => {
                if (res.status) {
                    this.setState({ emailAvailable: res.result.isExist });
                }
            });
        }
        else {
            onChange(this, name, value)
        }

    };

    onCondition1Change = () => {
        onChange(this, this.state.condition1.name, !this.state.condition1.value);
    };

    onCondition2Change = () => {
        onChange(this, this.state.condition2.name, !this.state.condition2.value);
    };

    verifyOTP = (otp) => {
        const { condition1, condition2, company_category, industry_type } =
            this.state;
        if (!condition2) {
            setError(
                this,
                condition2.name,
                "Please Accept Term & Condition and Privacy Policy"
            );
        }
        if (condition2) {
            setError(this, condition2.name, "");
        }
        if (company_category.value === "COMPANY" && industry_type.value === "") {
            setError(this, industry_type.name, "This field is required");
        }
        if (company_category.value !== "COMPANY") {
            setError(this, industry_type.name, "");
        }

        if (
            validateForm(this) &&
            condition2.value &&
            industry_type.error.length === 0
        ) {
            const {
                company_category,
                company_name,
                email,
                contact_person_name,
                industry_type,
                mobile,
                pin_code,
                gst,
                condition1,
                condition2,
                password,
                condfirm_password
            } = this.state;
            let m = formatPhoneNumberIntl(mobile.value);
            m = m.replace(/\s+/g, "");
            const model = {
                EMAIL: email.value,
                PHONE_CODE: formatPhoneNumberIntl(mobile.value).split(" ")[0],
                MOBILE: formatPhoneNumberIntl(mobile.value)
                    .split(" ")
                    .slice(1)
                    .join(""),
                // COMPANY_TYPE_ID:body.COMPANY_TYPE_ID,
                COMPANY_NAME: company_name.value.replace(/'/g, "\\'"),
                EMPLOYER_INDUSTRY_ID: industry_type.value,
                CONTACT_PERSON: contact_person_name.value.replace(/'/g, "\\'"),
                PINCODE: pin_code.value,
                PASSWORD: password.value,
                // URL: body.URL,
                mobile: m,
                EMPLOYER_CATEGORY: company_category.value,
                GSTIN: gst.value,
            };
            model.OTP = otp;
            this.props.onSubmit(model);
        }
    };
    onhideModal = () => {
        this.setState({ ShowOtpInput: false })
    }
    reSendOTP = () => {
        let m = formatPhoneNumberIntl(this.state.mobile.value);
        m = m.replace(/\s+/g, "");
        reSendOTP({ mobile: m }).then((res) => {
            if (res.type === "success") {
                Swal.fire({
                    icon: "success",
                    text: "OTP SENT SUCCESSFULLY",
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
            } else {
                this.setState({ resendOtpMessage: res.error });
            }
        });
    };
    render() {

        const redcheckbox = {
            "&::before": {
                border: "1px solid #ff0d0d",
            },
        };
        const { industryType } = this.props;
        const {
            company_category,
            showLoader,
            company_name,
            email,
            contact_person_name,
            industry_type,
            mobile,
            pin_code,
            gst,
            condition1,
            condition2,
            ShowOtpInput,
            resendOtpMessage,
            emailAvailable,
            showTimer,
            companyNameAvailable,
            password,
            condfirm_password,
            showPasswordOne,
            showPasswordTwo
        } = this.state;

        return (
            <React.Fragment>
                <section className="form-shared">
                    {showLoader && <Loader />}
                    {
                        ShowOtpInput && (
                            <ModalWindow1
                                title="OTP"
                                className="toppoup"
                                headerClassName="opthead"
                                backdrop="static"
                                toggleModal={this.onhideModal}

                            >
                                <Otp
                                    showTimer={showTimer}
                                    onCancel={this.onhideModal}
                                    mobile={this.state.mobile.value}
                                    // resendOtpMessage={resendOtpMessage}
                                    verifyOTP={this.verifyOTP}
                                    reSendOTP={this.reSendOTP}
                                />
                            </ModalWindow1>
                        )
                    }

                    {
                        !ShowOtpInput &&
                        <div className="billing-content">
                            <div className="contact-form-action">
                                <div className="registaion-hd-section">
                                    <h4>Post a free job</h4>
                                    <p>Join, post jobs, and effortlessly discover top talent for your company or clients!</p>
                                </div>
                                <form onSubmit={this.onSendOtp}>
                                    <div className="row">
                                        <div className="col-md-6 col-6">
                                            <label className="label-text">
                                                Choose your Company Type <span className="text-danger">*</span>
                                            </label>
                                            <div className="input-box first-tab-box mb-1 ">
                                                <div className="form-group">
                                                    <i className="la la-building-o form-icon"></i>
                                                    <button
                                                        onClick={(e) => {
                                                            this.chooseCompanyType(e, "COMPANY");
                                                        }}
                                                        className={
                                                            company_category.value === "COMPANY"
                                                                ? "form-control text-left caactive"
                                                                : "form-control text-left"
                                                        }
                                                    >
                                                        Company/Business
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-6">
                                            <label className="label-text">&nbsp;</label>
                                            <div className="input-box first-tab-box mb-1">
                                                <div className="form-group">
                                                    <i className="la la-users form-icon"></i>
                                                    <button
                                                        onClick={(e) => {
                                                            this.chooseCompanyType(
                                                                e,
                                                                "CONSULTANT"
                                                            );
                                                        }}
                                                        className={
                                                            company_category.value ===
                                                                "CONSULTANT"
                                                                ? "form-control text-left caactive"
                                                                : "form-control text-left"
                                                        }
                                                    >
                                                        Individual/Proprietor
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {company_category.value === "COMPANY" && (
                                            <div className="col-lg-12 column-lg-full">
                                                <label className="label-text">
                                                    Industry Type
                                                </label>
                                                <div className="input-box">
                                                    <div className="form-group">
                                                        <select
                                                            className="form-control pl-2 pt-2 pb-2"
                                                            name={industry_type.name}
                                                            onChange={this.onChange}
                                                        >
                                                            <option value="">
                                                                Select Industry Type
                                                            </option>
                                                            {industryType !== undefined &&
                                                                industryType.map((item, index) => {
                                                                    return (
                                                                        <option
                                                                            value={
                                                                                item.EMPLOYER_INDUSTRY_ID
                                                                            }
                                                                        >
                                                                            {item.INDUSTRY}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="col-md-6">
                                            <div className="input-box">
                                                <label className="label-text">
                                                    Your Company Name <span className="text-danger">*</span>
                                                </label>
                                                <div className="form-group">
                                                    <i className="la la-user form-icon"></i>
                                                    <input
                                                        className={
                                                            company_name.error && !company_name.value
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        type="text"
                                                        name={company_name.name}
                                                        value={company_name.value}
                                                        placeholder="Your Company Name"
                                                        onChange={this.onChange}
                                                    />
                                                    {company_name.error && !company_name.value && <span className="text-danger">{company_name.error}</span>}

                                                    {companyNameAvailable && (
                                                        <span
                                                            className="text-danger"
                                                            style={{ fontSize: "smaller" }}
                                                        >
                                                            This Company is already registered
                                                            with us
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input-box">
                                                <label className="label-text">
                                                    Your Officail Email <span className="text-danger">*</span>
                                                </label>
                                                <div className="form-group">
                                                    <i className="la la-envelope-o form-icon"></i>
                                                    <input
                                                        className={
                                                            email.error && !email.value
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        type="email"
                                                        name={email.name}
                                                        value={email.value}
                                                        onChange={this.onChange}
                                                        placeholder="Enter email address"
                                                    />
                                                    {email.error && !email.value && <span className="text-danger">{email.error}</span>}

                                                    {emailAvailable && (
                                                        <span
                                                            className="text-danger"
                                                            style={{ fontSize: "smaller" }}
                                                        >
                                                            This email is already registered
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input-box">
                                                <label className="label-text">
                                                    Mobile / Landline <span className="text-danger">*</span>
                                                </label>
                                                <PhoneInput
                                                    className={
                                                        mobile.error && !mobile.value
                                                            ? " PhoneInputInput is-invalid"
                                                            : " PhoneInputInput"
                                                    }
                                                    name={mobile.name}
                                                    value={mobile.value}
                                                    placeholder="Mobile / Landline"
                                                    onChange={(phone) =>
                                                        onChange(this, mobile.name, phone)
                                                    }
                                                    maxLength={11}
                                                    defaultCountry="IN"
                                                />
                                                {mobile.error && !mobile.value && <span className="text-danger">{mobile.error}</span>}

                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input-box">
                                                <label className="label-text">
                                                    Contact Person Name <span className="text-danger">*</span>
                                                </label>
                                                <div className="form-group">
                                                    <i className="la la-user form-icon"></i>
                                                    <input
                                                        className={
                                                            contact_person_name.error && !contact_person_name.value
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        type="text"
                                                        name={contact_person_name.name}
                                                        value={contact_person_name.value}
                                                        onChange={this.onChange}
                                                        placeholder="Contact Person Name"
                                                    />
                                                    {contact_person_name.error && !contact_person_name.value && <span className="text-danger">{contact_person_name.error}</span>}

                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-6">
                                            <div className="input-box">
                                                <label className="label-text">
                                                    Create Password <span className="text-danger">*</span>
                                                </label>
                                                <div className="form-group">
                                                    <span className="la la-lock form-icon"></span>

                                                    <input
                                                        className={
                                                            password.error && !password.value
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        type={showPasswordOne ? "text" : "password"}
                                                        name={password.name}
                                                        value={password.value}
                                                        onChange={this.onChange}
                                                        placeholder="Create Password"
                                                    />
                                                    {password.error && !password.value && <span className="text-danger">{password.error}</span>}

                                                    {password.value.length > 0 && <i onClick={() => { this.setState({ showPasswordOne: !showPasswordOne }) }} className={showPasswordOne ? 'fa fa-fw fa-eye toggle-password field-icon' : 'fa fa-fw fa-eye-slash toggle-password field-icon'} style={{ cursor: 'pointer', color: '#868d8f', right: "24px" }}></i>}

                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="input-box">
                                                <label className="label-text">
                                                    Confirm Password <span className="text-danger">*</span>
                                                </label>
                                                <div className="form-group">
                                                    <span className="la la-lock form-icon"></span>

                                                    <input
                                                        className={
                                                            condfirm_password.error && !condfirm_password.value
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        type={showPasswordTwo ? "text" : "password"}
                                                        name={condfirm_password.name}
                                                        value={condfirm_password.value}
                                                        onChange={this.onChange}
                                                        placeholder="Confirm Password"
                                                    />
                                                    {password.value !== condfirm_password.value && < span className="text-danger">{condfirm_password.error}</span>}
                                                    {condfirm_password.value.length > 0 && <i onClick={() => { this.setState({ showPasswordTwo: !showPasswordTwo }) }} className={showPasswordTwo ? 'fa fa-fw fa-eye toggle-password field-icon' : 'fa fa-fw fa-eye-slash toggle-password field-icon'} style={{ cursor: 'pointer', color: '#868d8f', right: "24px" }}></i>}

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input-box">
                                                <label className="label-text">
                                                    Pin Code <span className="text-danger">*</span>
                                                </label>
                                                <div className="form-group">
                                                    <NumberFormat
                                                        className={
                                                            pin_code.error
                                                                ? "form-control password-field pl-2 is-invalid"
                                                                : "form-control password-field pl-2"
                                                        }
                                                        // type='number'
                                                        name={pin_code.name}
                                                        value={pin_code.value}
                                                        onChange={this.onChange}
                                                        placeholder="Pin Code"
                                                        maxLength={6}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input-box">
                                                <label className="label-text">
                                                    GSTIN (Optional)
                                                </label>
                                                <div className="form-group">
                                                    <input
                                                        className={
                                                            gst.error
                                                                ? "form-control password-field pl-2 is-invalid"
                                                                : "form-control password-field pl-2"
                                                        }
                                                        type="text"
                                                        name={gst.name}
                                                        value={gst.value}
                                                        onChange={this.onChange}
                                                        placeholder="GSTIN (Optional)"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="input-box">
                                        <div className="custom-checkbox mr-0 align-items-center justify-content-between">

                                            <div>
                                                <input
                                                    type="checkbox"
                                                    onClick={this.onCondition2Change}
                                                    checked={condition2.value}
                                                    id="chb2"
                                                />
                                                <label
                                                    for="chb2"
                                                    style={redcheckbox}
                                                    className="font-size-13 font-weight-light"
                                                >
                                                    I Agree to JobzShala's{" "}
                                                    <a href="https://jobzshala.com/privacy-policy" target='_blank' className="color-text">
                                                        Privacy Policy,
                                                    </a>{" "}

                                                    <a href="https://jobzshala.com/terms-conditions" target='_blank' className="color-text">
                                                        Terms & Conditions &nbsp;
                                                    </a>
                                                    and Promotional Communication
                                                </label>
                                                {condition2.error.length > 0 && <span className="text-danger">Please Accept Privacy Policy and Term & Conditions.</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="btn-box register-btn-bx margin-top-10px">
                                        <button
                                            className="theme-btn border-0 register-button"
                                            type="submit"
                                            id='linked-in'
                                        >
                                            Register
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                    }
                </section>

                <div className="section-block"></div>
            </React.Fragment >
        );
    }
    onSendOtp = (e) => {
        e.preventDefault();
        const { condition1, condition2, company_category, industry_type, password, condfirm_password } =
            this.state;
        if (!condition2.value) {
            setError(
                this,
                condition2.name,
                "Please Accept Term & Condition and Privacy Policy"
            );
        }
        if (condition2.value) {
            setError(this, condition2.name, "");
        }
        if (company_category.value === "COMPANY" && industry_type.value === "") {
            setError(this, industry_type.name, "This field is required");
        }
        if (company_category.value !== "COMPANY") {
            setError(this, industry_type.name, "");
        }

        if (
            validateForm(this) &&
            condition2.value &&
            industry_type.error.length === 0
        ) {

            if (password.value === condfirm_password.value) {
                this.setState({ showLoader: true });
                const { mobile, email, company_name } = this.state;
                let m = formatPhoneNumberIntl(mobile.value);
                m = m.replace(/\s+/g, "");
                registerstepone({
                    mobile: m,
                    EMAIL: email.value,
                    COMPANY_NAME: company_name.value.replace(/'/g, "\\'"),
                    PHONE_CODE: formatPhoneNumberIntl(mobile.value).split(" ")[0],
                    MOBILE: formatPhoneNumberIntl(mobile.value)
                        .split(" ")
                        .slice(1)
                        .join(""),
                })
                    .then((res) => {
                        this.setState({ showLoader: false });
                        if (res?.result?.type === "success") {
                            this.setState({
                                ShowOtpInput: true, showTimer: true,
                            });

                        } else {
                            Swal.fire({
                                icon: "error",
                                text: res.error,
                                timer: 1500,
                                showCancelButton: false,
                                showConfirmButton: false,
                            });
                        }
                    })
                    .catch((err) => {
                        this.setState({ showLoader: false });
                        alert(err);
                    });
            }
            else {
                setError(
                    this,
                    condfirm_password.name,
                    "Confirm Password must be same as Create Password"
                );
            }
        }

    };
    onSubmit = () => {
        // e.preventDefault()
        const { condition1, condition2, company_category, industry_type } =
            this.state;
        if (!condition2) {
            setError(
                this,
                condition2.name,
                "Please Accept Term & Condition and Privacy Policy"
            );
        }
        if (condition2) {
            setError(this, condition2.name, "");
        }
        if (company_category.value === "COMPANY" && industry_type.value === "") {
            setError(this, industry_type.name, "This field is required");
        }
        if (company_category.value !== "COMPANY") {
            setError(this, industry_type.name, "");
        }

        if (
            validateForm(this) &&
            condition2.value &&
            industry_type.error.length === 0
        ) {
            const {
                company_category,
                company_name,
                email,
                contact_person_name,
                industry_type,
                mobile,
                pin_code,
                gst,
                condition1,
                condition2,
                password,
                condfirm_password
            } = this.state;
            if (password.value === condfirm_password.value) {

                const model = {
                    EMAIL: email.value,
                    PHONE_CODE: formatPhoneNumberIntl(mobile.value).split(" ")[0],
                    MOBILE: formatPhoneNumberIntl(mobile.value)
                        .split(" ")
                        .slice(1)
                        .join(""),
                    // COMPANY_TYPE_ID:body.COMPANY_TYPE_ID,
                    COMPANY_NAME: company_name.value.replace(/'/g, "\\'"),
                    EMPLOYER_INDUSTRY_ID: industry_type.value,
                    CONTACT_PERSON: contact_person_name.value.replace(/'/g, "\\'"),
                    PINCODE: pin_code.value,
                    // PASSWORD: body.PASSWORD,
                    // URL: body.URL,
                    EMPLOYER_CATEGORY: company_category.value,
                    GSTIN: gst.value,
                };
                this.props.onSubmit(model);
            }
            else {
                setError(
                    this,
                    condfirm_password.name,
                    "Confirm Password must be same as Create Password"
                );
            }
        }
    };
}
